export default __webpack_public_path__ + "55b846f4cf8d509d89e298b2d82a9ec8.svg";